<template>
  <div id="locusMap"></div>
</template>
<script>
var map, satelliteLayer;

var pathSimplifierIns;
var pointMarkers = []; //起始点
var listsPoint = []; //列表点
var navg0;
var set; //设置定时器
var markers = []; //收集点标注
var viaPointGroups = []; //途径点区域
var parks = []; //停车点
var alarms = []; //报警点
var infoWindow;
export default {
  props: ["isNavg", "type"],
  data() {
    return {
      lngLatArr: [],
      carSpeed: 500, //播放速度
      otherData: [], //点坐标其他属性
      startPoint: 0, //轨迹车俩初始停留点。为了点击详细列表反查车龄停留在哪用到，默认停留在起点
      curentPoint: 0, //节点位置
      getPosition: 0, //巡航器真是经纬度
      isDriver: false, //是否开启驾驶模式
      isYun: false,
    };
  },
  methods: {
    loadMap() {
      map = new AMap.Map("locusMap", {
        resizeEnable: true,
        defaultCursor: "",
      });
      var that = this;
      map.on("complete", function (ev) {
        infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(10, -14),
          showShadow: true,
          closeWhenClickMap: false,
          autoMove: false, //是否自动移动到视野范围
        });
        satelliteLayer = new AMap.TileLayer.Satellite();
        that.getbound();
      });

    },
    //获取地图边沿
    getbound() {
      var bounds = map.getBounds();
      var point = bounds.northeast;//116,30
      var point1 = bounds.southwest;//113,22
      console.log(point, point1);
      var marker = new AMap.Marker({
        offset: new AMap.Pixel(-0, -0),
        position: point,

      });
      marker.setMap(map);
      //map.setFitView();
      //map.panTo(point);
    },
    //加载高德ui轨迹
    loadUi(lnglat, data) {
      this.lngLatArr = lnglat;
      this.otherData = data;
      //this.lngLatArr = [];
      //this.otherData = [];
      var that = this;
      AMapUI.load(["ui/misc/PathSimplifier"], function (PathSimplifier) {
        if (!PathSimplifier.supportCanvas) {
          alert("当前环境不支持画布");
          return;
        }
        //启动页面
        that.initMap(PathSimplifier);
        //that.jiupian(data, PathSimplifier);
        that.startEndPoint();
      });
    },
    //初始化轨迹
    initMap(PathSimplifier) {
      var that = this;
      if (pathSimplifierIns != undefined) {
        //pathSimplifierIns.clearPathNavigators();
        pathSimplifierIns.setData([
          {
            name: "活动轨迹",
            path: [],
          },
        ]);
      }
      if (that.lngLatArr.length == 0) {
        return;
      }

      pathSimplifierIns = new PathSimplifier({
        zIndex: 100,
        map: map, //所属的地图实例
        clickToSelectPath: false, //点击轨迹线是否默认选中
        getPath: function (pathData, pathIndex) {
          //返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
          return pathData.path;
        },

        getHoverTitle: function (pathData, pathIndex, pointIndex) {
          if (pointIndex != undefined) {
            var car =
              "<p>速度：" +
              that.otherData[pointIndex].speed +
              "公里/小时</p>" +
              "<p>发动机：" +
              (that.otherData[pointIndex].accStatus == 1 ? "开" : "关") +
              "<p>里程：" +
              that.otherData[pointIndex].mileage +
              "公里</p>" +
              "<p>油耗电阻值：" +
              that.otherData[pointIndex].oil +
              "</p>";
            var content =
              "<div id='guijiHover'>" +
              "<p>" +
              that.otherData[pointIndex].gpsTime1 +
              '<span style="float:right">No:' +
              Number(pointIndex + 1) +
              "</span>" +
              "</p>" +
              "<p id='address111'></p>" +
              (that.type == "car" ? car : "") +
              "<p>事件报告：" +
              that.otherData[pointIndex].eventDesc +
              "</p>" +
              "</div>";
            return content;
          }
        },
        renderOptions: {
          //轨迹线的样式
          pathLineStyle: {
            strokeStyle: "#15ad2e",
            lineWidth: 6,
            dirArrowStyle: true,
          },
          //鼠标经过线的样式
          pathLineHoverStyle: {
            strokeStyle: "#15ad2e",
            lineWidth: 6,
            dirArrowStyle: true,
          },
          //选中的样式
          pathLineSelectedStyle: {
            strokeStyle: "#15ad2e",
            lineWidth: 6,
            dirArrowStyle: true,
          },
          //一次加载点个数
          renderAllPointsIfNumberBelow: 1000,
          //关键点样式
          keyPointStyle: {
            radius: 1, //点的大小
            fillStyle: "blue", //点的颜色
            strokeStyle: "#fff", //描边颜色
            lineWidth: 0, //描边大小
          },
          //鼠标经过关键点样式
          keyPointHoverStyle: {
            radius: 4,
            fillStyle: "blue",
            strokeStyle: "blue",
            lineWidth: 0,
          },
        },
      });
      //
      pathSimplifierIns.on("pointMouseover", function (e, info) {
        var pointList = [
          {
            x: info.pathData.path[info.pointIndex][0],
            y: info.pathData.path[info.pointIndex][1],
          },
        ];
        that.utils.jiexi(pointList).then((data) => {
          document.getElementById("address111").innerHTML = data[0].address;
        });
      });
      //这里构建两条简单的轨迹，仅作示例
      pathSimplifierIns.setData([
        {
          name: "活动轨迹",
          path: this.lngLatArr,
        },
      ]);
      /* pathSimplifierIns.on("pathClick pointClick", function(e, info) {
        console.log(info);
      }); */
      //pathSimplifierIns.on("pathMouseover", function (e, info) {});
      //pathSimplifierIns.on("pathClick", function (e, info) {});
      pathSimplifierIns.setFitView();
      //创建一个巡航器
      var runIcon =
        that.type == "car"
          ? that.axios.platConfig.fileUri + "mapicon/" + "arrow/2/1.gif"
          : that.axios.platConfig.fileUri + "mapicon/" + "arrow/2/1.gif";
      var runIcon = "static/arrow.gif";
      var content = PathSimplifier.Render.Canvas.getImageContent(
        runIcon,
        //https://cloud.ly-gps.com/files/ly-cloud/mapicon/arrow/2/1.gif
        function onload() {
          //图片加载成功，重新绘制一次
          pathSimplifierIns.renderLater();
        }
      );
      if (!that.isNavg) {
        return;
      }
      navg0 = pathSimplifierIns.createPathNavigator(
        0, //关联第1条轨迹
        {
          loop: true, //循环播放
          speed: this.carSpeed,
          pathNavigatorStyle: {
            width: 30,
            height: 30,
            content: content,
            //走过的路线
            /* pathLinePassedStyle: {
              strokeStyle: "red",
              lineWidth: 6,
            }, */
            pathLinePassedStyle: {
              lineWidth: 2,
              strokeStyle: "rgba(8, 126, 196, 1)",
              borderWidth: 1,
              borderStyle: "#eeeeee",
              dirArrowStyle: false,
            },
          },
        }
      );
      /*
      //跟车移动 
      navg0.marker = new AMap.Marker({
        offset: new AMap.Pixel(12, -10),
        //content: "<div>当前速度 :" + navg0.getSpeed() + "</div>", //设置当前点信息窗口显示内容
        content: "", //设置当前点信息窗口显示内容
        map: map
      }); */
      navg0.on("move", function (e) {
        that.getPosition = navg0.getPosition();
        // navg0.marker.setPosition(navg0.getPosition());//跟车移动
        //console.log(navg0.getCursor());
        var cursor = navg0.getCursor();
        that.curentPoint = Math.round(cursor.idx);
        that.$emit("curentPoint", that.curentPoint, that.lngLatArr.length);
      });
      // navg0.start();
    },
    //播放/暂停
    play(val) {
      switch (val) {
        case 1: //播放

          this.toCenter();
          navg0.start();
          break;
        case 2: //暂停
          navg0.pause();
          clearInterval(set);
          break;
        case 3: //继续
          navg0.resume();
          this.toCenter();
          break;
        case 4: //销毁
          clearInterval(set);
          navg0.destroy();
          break;
      }
    },
    //接受到的速度
    reSpeed(s) {
      this.carSpeed = s * 100;
      navg0.setSpeed(this.carSpeed);
      //this.play(1);
    },
    //点击进度条，小车会移动到指定位置
    reSlider(n) {
      //
      if (this.$store.state.carMsg.play == 1) {
        this.play(1);
      } else {
        this.play(3);
      }
      this.$store.state.carMsg.play = 2;
      this.curentPoint = Number(this.gpsData.length - 1) * n * 0.01;
      //this.$store.state.carMsg.play = 2;
      navg0.moveToPoint(Math.round(this.curentPoint), 0.2);

      setTimeout(() => {
        map.panTo(this.getPosition);
        this.$store.state.carMsg.play = 3;
        this.play(2);
      }, 50);
    },
    //车辆出范围拉回中心区域
    toCenter() {
      
      //粤BEQ034
      set = setInterval(() => {
        var bounds = map.getBounds();
      var ne = bounds.northeast;//116,30
      var sw = bounds.southwest;//113,22
        var now = this.getPosition;
        if (!(now.lng > sw.lng && now.lng < ne.lng && now.lat > sw.lat && now.lat < ne.lat)) {
          map.panTo(now);
          
        }

      }, 1000);
    },
    startEndPoint(v) {
      map.remove(pointMarkers);
      var m = 0;
      var data = this.otherData;
      var last = data.length > 1 ? data.length - 1 : 0;
      if (last > 1) {
        var alllength = (data[last].mileage - data[0].mileage).toFixed(
          2
        );

        var tt = (data[last].gpsTime - data[0].gpsTime) / 1000;
        var allTime = this.utils.duration(tt);
      }
      for (var i = 0, marker; i < this.lngLatArr.length; i++) {
        if (i == 0 || i == this.lngLatArr.length - 1) {
          i == 0 ? (m = 0) : (m = 1);
          var icon = new AMap.Icon({
            size: new AMap.Size(100, 100), // 图标尺寸
            image: "static/" + m + ".gif", // Icon的图像
            imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
            imageSize: new AMap.Size(24, 32), // 根据所设置的大小拉伸或压缩图片
          });
          marker = new AMap.Marker({
            position: this.lngLatArr[i],
            icon: icon,
            map: map,
            offset: new AMap.Pixel(-12, -36),
          });
          if (m == 1) {
            marker.setLabel({
              content: "<p>" + alllength + "公里</p><p>" + allTime + "</p>",
              offset: new AMap.Pixel(20, 20),
            });
          }
          pointMarkers.push(marker);
        }
      }
    },
    //开启夜间模式/白天模式
    dark() {
      if (!this.$store.state.isdark) {
        map.setMapStyle("amap://styles/6bd83b3bf912d2e1c2961f735685146f");
      } else {
        map.setMapStyle("amap://styles/normal");
      }
    },
    //绘制途径点
    timesPoint(points) {
      return;
      map.remove(markers);
      if (viaPointGroups != undefined) {
        map.remove(viaPointGroups);
      }
      var polyArrs = [];
      for (const i in points) {
        var lnglat = [points[i].locateLng, points[i].locateLat];
        var Marker = new AMap.Marker({
          position: lnglat,
          //icon: icon,
        });
        Marker.setLabel({
          content:
            "<div class='myInfo' style='font-size:12px'>" +
            points[i].name +
            "</div>",
          offset: new AMap.Pixel(20, 5),
        });
        map.add(Marker);
        markers.push(Marker);
        var circle = new AMap.Circle({
          center: lnglat,
          radius: points[i].radius, //半径
          borderWeight: 3,
          strokeColor: "#FF33FF",
          strokeOpacity: 1,
          strokeWeight: 6,
          strokeOpacity: 0.3,
          fillOpacity: 0.2, //填充颜色
          strokeStyle: "dashed",
          strokeDasharray: [10, 10],
          // 线样式还支持 'dashed'
          fillColor: "#1791fc",
        });
        polyArrs.push(circle);
      }
      viaPointGroups = new AMap.OverlayGroup(polyArrs);
      map.add(viaPointGroups);
    },
    //点击列表渲染
    drawPoint(v) {
      map.remove(listsPoint);
      var point = [v.locateLng, v.locateLat];
      var icon = new AMap.Icon({
        //size: new AMap.Size(26, 26), // 图标尺寸
        image: "http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png", // Icon的图像
        imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
        imageSize: new AMap.Size(20, 30), // 根据所设置的大小拉伸或压缩图片
      });
      var marker = new AMap.Marker({
        map: map,
        position: point,
        icon: icon,
        offset: new AMap.Pixel(-10, -28),
      });
      listsPoint.push(marker);
      map.panTo(point)
    },
    showpark(v, m) {
      map.remove(parks);
      parks = [];
      var k = 1;
      console.log('停车', m);

      for (var i = 0, marker; i < v.length; i++) {
        var icon = new AMap.Icon({
          //size: new AMap.Size(20, 26), // 图标尺寸
          image: "static/park.png", // Icon的图像
          imageOffset: new AMap.Pixel(6, 10), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(12, 18), // 根据所设置的大小拉伸或压缩图片
        });
        if (v[i].parkDuration > m) {
          marker = new AMap.Marker({
            map: map,
            position: [v[i].locateLng, v[i].locateLat],
            icon: icon,
          });
          marker.setLabel({
            content: "<div>" + v[i].parkDuration1 + "</div>",
            offset: new AMap.Pixel(20, 20),
          });
          marker.content =
            "<div><p>" +
            v[i].address +
            "</p><p>停车时长：" +
            v[i].parkDuration1 +
            "</p><p>开始停车：" +
            v[i].startParkTime +
            "</p><p>结束停车：" +
            v[i].endParkTime +
            "</p></div>";
          k++;

          marker.on("click", markerClick);
          parks.push(marker);
        }
      }

      map.add(parks);
      function markerClick(e) {
        infoWindow.setContent(e.target.content);
        infoWindow.open(map, e.target.getPosition());
      }
    },
    showAlarm(v) {
      map.remove(alarms);
      alarms = [];
      var k = 1;
      for (var i = 0, marker; i < v.length; i++) {
        var icon = new AMap.Icon({
          //size: new AMap.Size(20, 26), // 图标尺寸
          image: "static/alarm.png", // Icon的图像
          imageOffset: new AMap.Pixel(6, 10), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(18, 18), // 根据所设置的大小拉伸或压缩图片
        });

        marker = new AMap.Marker({
          map: map,
          position: [v[i].startlocateLng, v[i].startlocateLat],
          icon: icon,
        });
        marker.content =
          "<div><h2 style='font-size:1.3em;margin-bottom:6px;'>" +
          v[i].info +
          "</h2><p>" +
          v[i].startTime +
          "</p><p>" +
          v[i].startAdd +
          "</p></div>";
        k++;

        marker.on("click", markerClick);
        alarms.push(marker);
      }

      map.add(alarms);
      function markerClick(e) {
        infoWindow.setContent(e.target.content);
        infoWindow.open(map, e.target.getPosition());
      }
    },
    //点击围栏，将围栏渲染到地图
    showFences(v) {
      this.utils.showFences(map, v);
    },
    //单机路线规划，显然线路到地图
    showLines(v) {
      this.utils.showLines(map, v);
    },
    showWorksLines(v) {
      this.utils.showWorksLines(map, v);
    },
    //点击标注点，渲染到地图
    showPoints(v) {
      this.utils.showPoints(map, v);
    },
    //显示垃圾桶
    showLjt(data_info) {
      map.remove(markers);
      markers = [];
      for (var i = 0, marker; i < data_info.length; i++) {
        var icon = new AMap.Icon({
          size: new AMap.Size(24, 24), // 图标尺寸
          image: "static/ljt1.png", // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(24, 24), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        marker = new AMap.Marker({
          map: map,
          position: [data_info[i].x, data_info[i].y],
          icon: icon,
          offset: new AMap.Pixel(-12, -12),
          zIndex: 1000,
        });
        marker.setLabel({
          content: "<div>" + data_info[i].name + "</div>",
          offset: new AMap.Pixel(26, 6),
        });

        markers.push(marker);
      }
      map.setFitView();
      //infoWindow.on("close", alert('关闭'));
    },
    //云图
    reYun(t) {
      this.isYun = !this.isYun;
      if (this.isYun) {
        map.add(satelliteLayer);
      } else {
        map.remove(satelliteLayer);
      }
    },
    reset() {
      this.showLines([]);
      this.showLjt([]);
    },
  },
  mounted() {

    var kk;
    kk = setInterval(() => {
      if (AMap) {
        this.loadMap();
        clearInterval(kk);
      }
    }, 200)
  },
};
</script>
<style lang="">
#locusMap {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/map/locusMap.vue